module.exports = "pegasus_template/assets/hexagon-google.gif";